import { z } from 'zod';

import { UserStatus } from 'src/api';

import { FormFields } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormFields.status]: z.enum(UserStatus),
  [FormFields.isAbleToManagePlatformStaff]: z.boolean(),
}) satisfies z.ZodType<FormValues>;
